import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { company, companyType } from '../../types/slices/companyType'

const initialState: companyType =
{
    status: ApiStatus.FETCHED,
    companies: [],
    companySelected: {} as company,
    errorMessage: undefined,
    action: ''
}

const companySlice = createSlice({
    name: 'companySlice',
    initialState,
    reducers: {
        onFetchCompanies (state, { payload }: { payload: company[]}) {
        state.status = ApiStatus.FETCHED
        state.companies = payload
        state.errorMessage = undefined
        },
        onSetSelectedCompany (state, { payload }: { payload: company }) {
        state.companySelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectCompanyState = (state: RootState) => state.companySlice
export default companySlice.reducer
export const {
    onFetchCompanies,
    onSetSelectedCompany,
    changeStatus,
    setAction,
} = companySlice.actions
